import {
  NotificationParams,
  useNotification,
} from "@/providers/notifications-bot-actions/notifications-bot-actions";
import { api, type Api } from "@api/bot-base-api-request";
import { useMutation } from "@tanstack/react-query";

const BOT_TRANSFER_NATIVE_QUERY_KEY = "bot-transfer-native";

type BotTransferNativeParams = {
  appPubKey: string;
  to: string;
  amount: string;
  walletAddress: string;
  userId: string;
  chainId: number;
};

type BotTransferNativeInput = {
  params: BotTransferNativeParams;
  notifyParams: NotificationParams;
};

const postBotTransferNative = async (
  api: Api,
  params: BotTransferNativeParams
) => api.post("transfer/transferNative", { json: params }).json();

const useBotTransferNativeMutation = () => {
  const { setNotifyProps } = useNotification();

  return useMutation<unknown, Error, BotTransferNativeInput>({
    mutationFn: async (input: BotTransferNativeInput) =>
      await postBotTransferNative(api, input.params),
    mutationKey: [BOT_TRANSFER_NATIVE_QUERY_KEY],
    onSuccess: async (_data, variables) => {
      setNotifyProps({
        type: "success",
        action: "sendToken",
        params: {
          amount: variables.notifyParams.amount,
          tokenSymbol: variables.notifyParams.tokenSymbol,
          walletAddress: variables.params.walletAddress,
        } as NotificationParams,
      });
    },
    onError: async (_error, variables) => {
      setNotifyProps({
        type: "error",
        action: "sendToken",
        params: {
          amount: variables.notifyParams.amount,
          tokenSymbol: variables.notifyParams.tokenSymbol,
          walletAddress: variables.params.walletAddress,
        } as NotificationParams,
      });
    },
  });
};

export {
  useBotTransferNativeMutation,
  postBotTransferNative,
  BOT_TRANSFER_NATIVE_QUERY_KEY,
};
